import type {RouteRecordRaw} from 'vue-router';
import {propositionGuard} from '@/router/guards/propositionGuard';

export const shopSettingsCompanyRoutes: RouteRecordRaw[] = [
  {
    name: 'shop-settings-company',
    path: 'contact',
    component: () => import('@/views/Settings/Shop/Company/CompanyIndex.vue'),
    meta: {
      permissions: ['updateShopBillingSettings', 'updateShopReturnAddress', 'updateShopDeliveryAddress'],
      title: (t) => t('settings.shop.company.title'),
    },
    children: [
      {
        name: 'shop-settings-company-billing',
        path: '',
        component: () => import('@/views/Settings/Shop/Company/CompanyContact/CompanyContact.vue'),
        meta: {
          permissions: ['updateShopBillingSettings'],
        },
      },
      {
        name: 'shop-settings-company-return',
        path: 'return-address',
        component: () => import('@/views/Settings/Shop/Company/ReturnAddress/ReturnAddress.vue'),
        meta: {
          permissions: ['updateShopReturnAddress'],
        },
      },
      {
        name: 'shop-settings-company-export',
        path: 'export',
        component: () => import('@/views/Settings/Shop/Company/ExportSettings/ExportSettings.vue'),
        meta: {
          permissions: ['updateShopBillingSettings'],
        },
      },
      {
        name: 'shop-settings-company-webshop',
        path: 'delivery-address',
        beforeEnter: (to, from) => {
          return propositionGuard(to, from, (proposition) => {
            return proposition.applications.webshop.enabled;
          });
        },
        component: () => import('@/views/Settings/Shop/Company/WebshopAddress/WebshopAddress.vue'),
        meta: {
          permissions: ['updateShopDeliveryAddress'],
        },
      },
      {
        name: 'shop-settings-company-bank',
        path: 'bank-details',
        component: () => import('@/views/Settings/Shop/Company/Bank/BankSettings.vue'),
        meta: {
          permissions: ['updateShopBillingSettings'],
        },
      },
    ],
  },
];
